/**
 * Arama metnini normalize eder: büyük/küçük harf ve Türkçe karakter duyarsız.
 *
 * Neden gerekli: `toUpperCase()` Türkçe'de kırılır — "istanbul".toUpperCase() → "ISTANBUL"
 * ama "İstanbul".toUpperCase() → "İSTANBUL"; noktalı İ ile noktasız I eşleşmez. Aynı şekilde
 * kullanıcı "gorusme" yazınca "görüşme" bulunmalı (aksan duyarsız).
 *
 * Yöntem: önce Türkçe'ye özel harfleri ASCII karşılığına çevir, sonra kalan aksanları
 * Unicode NFD ile ayrıştırıp at, sonra küçült.
 */
const TR_MAP = {
    'İ': 'i', 'I': 'i', 'ı': 'i', 'i': 'i',
    'Ş': 's', 'ş': 's',
    'Ğ': 'g', 'ğ': 'g',
    'Ü': 'u', 'ü': 'u',
    'Ö': 'o', 'ö': 'o',
    'Ç': 'c', 'ç': 'c',
};

export function normalizeSearch(value)
{
    if (value == null) return '';
    return String(value)
        .replace(/[İIıiŞşĞğÜüÖöÇç]/g, (ch) => TR_MAP[ch])
        .normalize('NFD')            // kalan aksanlar (é, ñ…) ayrıştırılır
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase();
}

/** `text` içinde `query` geçiyor mu — büyük/küçük ve Türkçe karakter duyarsız. */
export function matchesSearch(text, query)
{
    const q = normalizeSearch(query).trim();
    if (!q) return true;
    return normalizeSearch(text).includes(q);
}

/**
 * antd Select için hazır `filterOption`.
 * Etiket alanı özelse anahtarını geç: selectFilterOption('name')
 */
export const selectFilterOption = (labelKey = 'label') =>
    (input, option) => matchesSearch(option?.[labelKey] ?? option?.label ?? option?.children, input);
